
import { createSelector } from 'reselect';
import Immutable from 'immutable';

import { getUGCListByUsers } from './UGCBaseSelector';

const getTransactions = state => state.getIn(['ugc', 'similarTitlesTransactions'], Immutable.Map());

export const getSimilarTitlesByUsers = getUGCListByUsers('similarTitles');

export const getSimilarTitlesTransactions = createSelector([getTransactions], (transactions) => transactions);

export default {
  getSimilarTitlesByUsers,
  getSimilarTitlesTransactions
};



// WEBPACK FOOTER //
// ./app/selectors/ugc/SimilarTitlesSelector.js